export enum LinkTextStyles {
	REGULAR = 'Regular',
	MEDIUM = 'Medium',
	BOLD = 'Bold',
	UNDERLINE = 'Underline',
	CENTERED = 'Centered'
}
export enum LinkStyles {
	PRIMARY = 'Primary',
	SECONDARY = 'Secondary',
	DROPDOWN = 'Dropdown',
	ASIDE = 'Aside',
	GO_BACK = 'GoBack'
}

export enum LinkSizes {
	WIDE = 'Wide'
}

export enum LinkTypes {
	DEFAULT,
	TARGET_BLANK,
	ASIDE,
	DROPDOWN,
	BACK
}
